export class Formatter {

    public static number(n: number, language: string): string {

        if (typeof Intl === 'object' && typeof Intl.NumberFormat === 'function') {

            const formatter = new Intl.NumberFormat(language, { notation: 'standard' })

            return formatter.format(n);
        }

        return n.toString();
    }
}